/* The footer's link columns, as accordions on a phone. v1.
   Paired with rockkt-foot-mobile-v1.css, which holds every rule and every
   breakpoint. This file adds a class, three attributes and two listeners.

   WHY. At 390px the footer measured 1,641px, and 717px of that was three
   columns of links stacked one under the other. Collapsed they are 151px and
   the footer is 1,068px. The numbers and the reasoning are in the stylesheet.

   WHAT IT TOUCHES. Every .foot-col inside <footer>: adds .rk-fa, and on the
   column's own h4 sets role="button", tabindex and aria-expanded. It moves no
   nodes and rewrites no markup, which matters because rockkt-footer-sync-v3.js
   owns the contents of these columns and rebuilds the Features one on every
   template. Rebuilds are picked up by the observer at the bottom.

   ABOVE 620px IT UNDOES ITSELF. The role, the tabindex and aria-expanded come
   straight back off and any open column is closed, because above that width the
   stylesheet shows every link anyway and a heading that says it is a button and
   does nothing is worse than no button at all. That runs on every media-query
   change, so a rotated phone or a dragged window ends up consistent.

   IF THIS FILE FAILS TO LOAD nothing is hidden: the stylesheet only ever
   matches .foot-col.rk-fa, and the class is added here. The footer degrades to
   exactly what it is today. */
(function () {
  var MQ = '(max-width: 620px)';
  var mq = window.matchMedia ? window.matchMedia(MQ) : null;

  function columns() {
    var f = document.querySelector('footer');
    return f ? f.querySelectorAll('.foot-col') : [];
  }

  function small() { return mq ? mq.matches : false; }

  function toggle(col, h) {
    if (!small()) return;              /* desktop: the heading is just a heading */
    var open = col.classList.toggle('open');
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* Wire a column once. Re-running is free: the .rk-fa check is the guard. */
  function wire(col) {
    if (col.classList.contains('rk-fa')) return;
    var h = col.querySelector('h4');
    if (!h) return;                    /* no heading, nothing to tap */
    col.classList.add('rk-fa');
    h.addEventListener('click', function () { toggle(col, h); });
    h.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'Enter' || k === ' ' || k === 'Spacebar') {
        e.preventDefault();
        toggle(col, h);
      }
    });
  }

  /* Attributes follow the viewport, not the markup. */
  function sync() {
    var isSmall = small();
    [].forEach.call(columns(), function (col) {
      var h = col.querySelector('h4');
      if (!h) return;
      if (isSmall) {
        h.setAttribute('role', 'button');
        h.setAttribute('tabindex', '0');
        h.setAttribute('aria-expanded', col.classList.contains('open') ? 'true' : 'false');
      } else {
        col.classList.remove('open');
        h.removeAttribute('role');
        h.removeAttribute('tabindex');
        h.removeAttribute('aria-expanded');
      }
    });
  }

  function run() {
    [].forEach.call(columns(), wire);
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  /* rockkt-footer-sync-v3.js builds the Features column after this may have run,
     and does it again on some templates. childList only, and this script adds
     nothing but classes and attributes, so it cannot retrigger itself. */
  function observe() {
    var f = document.querySelector('footer');
    if (!f || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(f, { childList: true, subtree: true });
  }
  window.addEventListener('load', function () { run(); observe(); });

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }
})();
